/**
 * Created by dx.yang on 2017/2/22.
 */


export default {
    name: 'KsTableKvmHeader',
    props: {
        store: null,
    },
    data () {
        return {
            _initX: '',
            lastTh: '',
            $table: '',
            originWidth: 0
        }
    },
    methods: {
        filterClick(e, f, c) {
            c.show = false;
            this.store.commit('changeFilter', f);
        },
        showFilterList(c) {
            c.show = true;
        },
        hideFilterList(c) {
            c.show = false;
        },
        doSort(col) {
            let currentSort = this.store.states.currentSort;
            if (!currentSort.field) {
                currentSort.state = 'down';
            } else if (currentSort.field == col.field) {
                currentSort.state = {
                    down: 'up',
                    up: 'down'
                }[currentSort.state];
            }

            currentSort.field = col.field;
            currentSort.by = col.sort;
            this.store.commit('setSort');
        },
        checkAll() {
            this.store.commit('checkAll');
        },
        mouseoverHandler(e, c) {
            $("#"+c.uuid.hex).show()
        },
        mouseoutHandler(e, c) {
            $("#"+c.uuid.hex).hide()
        },
        _dragStart(e, c, idx) {
            if(!this.store.states.dragCheck) return;
            this.store.commit('dragChange', true);
            var $currentTh = $(e.target.closest('th'));
            this.$lastTh = _.last(this.store.states.columns); 
            this._initX = e.clientX;
            $(document)
                .on('mousemove.table', _.bind(this._move, this, c))
                .on('mouseup.table', _.bind(this._dragEnd, this));
        },
        _move(c, e) {
            if(!this.store.states.dragCheck) return;
            if (this.store.states.drag) {
                var delX = e.clientX - this._initX,
                    nowWidth = Number(c.realWidth) + delX,
                    tableWidth = this.$table.width() + delX;
                if (nowWidth < (c.width || 20)) {
                    return;
                }
                c.realWidth = nowWidth;
                this.$table.width(tableWidth);
                if (this.originWidth > tableWidth) {
                    // 如果表格拖动到小于容器宽度，则保持表格宽度为容器的宽度，去改变最后一列宽度
                    const lastWidth = this.$lastTh.realWidth - delX;
                    this.$lastTh.realWidth = lastWidth;
                    this.$table.width(this.originWidth);
                } else {
                    this.$table.width(tableWidth);
                    $(".view-main-container").width(tableWidth);
                }
                this._initX = e.clientX;
            }
        },
        _dragEnd() {
            if(!this.store.states.dragCheck) return;
            if (this.store.states.drag) {
                this.store.commit('dragChange', false);
                $(document)
                    .off('mousemove.table')
                    .off('mouseup.table');
            }
        }
    },
    mounted() {
        this.$table = $(this.$el).parent().parent();
        let w = $(this.$table).width();
        if(w == 0) return;
        this.originWidth = $(this.$table).width() - 20;
        console.log(this.originWidth, $(this.$table).width())
    },
    render(h) {
        let states = this.store.states;
        let cols = states.columns;

        let ths = [];

        if (states.select.enabled) {
            let classes = 'ks-table-new-style-'+ states.select.mode +' all-checked';
            if (states.checkedList.length != 0 && states.checkedList.length == states.rows2show.length) {
                classes += ' be-checked';
            }
            ths.push(
                <th>
                    <div class={classes}
                         on-click={ () => { this.checkAll() } }>
                        <div class="inner-checkbox">
                            <div class="inner-checkbox-dot"></div>
                        </div>
                    </div>
                </th>
            )
        }



        cols.forEach((c, idx) => {
            let thContent = [];
            if (c.sort) {
                let direct = 'fa fa-sort';
                let currentSort = states.currentSort;
                if (currentSort.field === c.field) {
                    switch (currentSort.state) {
                        case 'up':
                            direct = 'fa fa-sort-up';
                            break;
                        case 'down':
                            direct = 'fa fa-sort-down';
                            break;
                        default: break;
                    }
                }
                thContent.push(<span class="ks-th-sort-tip">
                    <i class={direct}></i>
                </span>)
            }

             let tipmsg = c.tipmsg
            if (c.tips) {
                thContent.push(
                    <div class='table-header-tip'>
                        <div 
                        on-mouseover={ (e) => { this.mouseoverHandler(e,c) } }
                        on-mouseout={ (e) => { this.mouseoutHandler(e,c) } }
                        class="table-header-tooltip"
                        >
                            <span>
                                <i class="table-header-icon table-header-icon-question"></i>
                            </span>
                        </div>
                        <div id={c.uuid.hex} class="table-header-tip-content">
                            <span class="table-header-tip-msgs">{c.tipmsg}</span>
                        </div>
                    </div>
                )
            }


            let label = c.label;
            if (c.filter) {

                //let currentFilter = _.isEmpty(states.currentFilter) ? c.filter[0] : states.currentFilter;
                // console.log(states.currentFilter);
                // _.forEach(states.currentFilter, (item, field) => {
                //
                // });
                let currentFilter;
                for (let i = 0; i < c.filter.length; i++) {
                    let f = c.filter[i].field;
                    currentFilter = states.currentFilter[f];
                    if (!currentFilter) {
                        continue;
                    }
                }

                thContent.push(
                    <div class="th-filter-div"
                         on-mousemove={ ()=>{this.showFilterList(c)} }
                         on-mouseout={ ()=>{this.hideFilterList(c)} }>
                        <div class="ks-ctrl-collapse">
                            <div class="ks-ctrl-collapse-down"></div>
                        </div>
                        <ul class="ks-dropdown-menu" style={ c.show ? 'display:inline-block' : 'display:none' }>
                            {
                                c.filter.map(f => {
                                    return (
                                        <li class={ currentFilter.field == f.field && currentFilter.value === f.value ? 'active' : '' }>
                                            <a href="javascript:;" on-click={ ($event) => this.filterClick($event, f, c)}>{f.title}</a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                );
                label += `(${currentFilter.title})`;
            }
            if (c.sort) {
                ths.push(
                    <th class='sort-th' style={c.visible ? 'display:table-cell' : 'display: none'}
                        on-click={ () => this.doSort(c) }>
                        <span class={c.className}>{label}</span> {thContent.map(t => t)}
                        <div class="drag-line" on-mousedown={ ($event) => this._dragStart($event, c, idx) }></div>
                    </th>
                )
            } else {
                ths.push(
                    <th style={c.visible ? 'display:table-cell' : 'display: none'}>
                        <span class={c.className}>{label}</span> {thContent.map(t => t)}
                        <div class="drag-line" on-mousedown={ ($event) => this._dragStart($event, c, idx) }></div>
                    </th>
                )
            }
        });

        return (
            <table class="ks-table">
                <colgroup>
                    {
                        states.select.enabled && <col width='40' />
                    }
                    {
                        cols.map(c => c.visible ? <col width={c.realWidth} />: undefined)
                    }
                    {
                        <col />
                    }
                </colgroup>
                <thead>
                <tr>
                    { ths.map(th => th) }
                </tr>
                </thead>
            </table>
        );
    }
}